import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Actor } from '../../model/actor';
import { StartupService } from '../../services/startup.service';
import { TimeValidation } from '../../validators/timeValidation'
import { DayPilot } from "daypilot-pro-angular";
import * as moment from 'moment';
import { UntypedFormGroup, UntypedFormControl, AbstractControl, ValidatorFn, UntypedFormBuilder, Validators } from '@angular/forms';
import { DateTimeUtils } from '../../shared/datetimeutils'
import { BusEnum, EditModeEnum, AdminEnum, EventTypes } from '../../common/enums';
import { StateMachineEventEnum } from '../../model/stateMachineEvent';
import { ConfirmDialog } from '../../confirmation/confirm.dialog';
import { ActivityActorEvent } from "../../model/activityActor-event";
import { Subscription } from 'rxjs';
import { WorkShift } from '../../model/workShift';
import { ActivityDialogEvent } from '../scheduler-upper/activityDialogEvent';

@Component({
  selector: 'app-edit-event-dialog',
  templateUrl: './edit-event-dialog.component.html',
  styleUrls: ['./edit-event-dialog.component.css'],

})
export class EditEventDialogComponent implements OnInit {

  readonly ActivityActiveStatus = "ACTIVE";

  formTest: UntypedFormGroup;
  timeGroup: UntypedFormGroup;
  driverControl = new UntypedFormControl();
  commentControl: UntypedFormControl;
  startTimeControl: UntypedFormControl;
  startLocationControl: UntypedFormControl;
  endLocationControl: UntypedFormControl;
  durationControl: UntypedFormControl;
  typeControl: UntypedFormControl;
  billedControl: UntypedFormControl;
  descriptionControl: UntypedFormControl;
  typeNameControl: UntypedFormControl;

  eventTypes: EventType[] = [];
  activityActorEvents: ActivityActorEvent[];
  updateActivitySubscription: Subscription;

  actor: Actor;
  title: string;
  miscName: string;
  existing: boolean = false;

  maxDescriptionChars: number = 5;

  confirmModalRef: MatDialogRef<ConfirmDialog>;

  @ViewChild('eventPicker') eventPicker: MatSelect;

  constructor(@Inject(MAT_DIALOG_DATA)
    public data: ActivityDialogEvent,
    private dialogRef: MatDialogRef<EditEventDialogComponent>,
    private fb: UntypedFormBuilder,
    public startupService: StartupService) {

    this.eventTypes = EventTypes.filter(x => x.available);
    this.existing = data.existing;
    this.data.locations = this.data.locations.filter(x => x.type === "G" || x.type === "S");

    this.billedControl = new UntypedFormControl({ value: data.activityEvent.billed, disabled: !this.canEdit() });
    this.typeControl = new UntypedFormControl({ value: data.activityEvent.actor.type, disabled: !this.canEdit() });
    this.commentControl = new UntypedFormControl({ value: data.activityEvent.comment, disabled: !this.canEdit() });
    this.startLocationControl = new UntypedFormControl({ value: data.activityEvent.startLocation, disabled: !this.canEdit() });

    if ((data.activityEvent.type === BusEnum.Air || data.activityEvent.type === BusEnum.Land)) {
      this.startLocationControl.setValidators(Validators.required);
    }

    this.durationControl = new UntypedFormControl({ value: data.activityEvent.duration, disabled: !this.canEditDuration() }, Validators.required);

    let actorName = data.activityEvent.actor.name;

    if (data.activityEvent.actor.name === "Admin") {
      this.typeNameControl = new UntypedFormControl(AdminEnum.Break);
    }
    else if (actorName !== AdminEnum.Break
      && actorName !== AdminEnum.Fuel
      && actorName !== AdminEnum.Coffe
      && actorName !== AdminEnum.Wash
      && actorName !== AdminEnum.Meeting
      && actorName !== AdminEnum.Clean
      && actorName !== AdminEnum.Standby
      && actorName !== AdminEnum.StandbyDE
      && actorName !== AdminEnum.StandbyPalace
      && actorName !== AdminEnum.Flight
      && actorName !== AdminEnum.BusBooking
      && actorName !== AdminEnum.TransferPortalFrom
      && actorName !== AdminEnum.TransferPortalTo) {
      this.typeNameControl = new UntypedFormControl({ value: AdminEnum.Misc, disabled: !this.canEdit() });
    }
    else {
      this.typeNameControl = new UntypedFormControl({ value: data.activityEvent.actor.name, disabled: !this.canEdit() });
    }

    if (this.typeNameControl.value === AdminEnum.Flight || this.typeNameControl.value === AdminEnum.BusBooking || this.typeNameControl.value === AdminEnum.TransferPortalFrom || this.typeNameControl.value === AdminEnum.TransferPortalTo)
      this.descriptionControl = new UntypedFormControl(data.activityEvent.actor.description);
    else
      this.descriptionControl = new UntypedFormControl(this.typeNameControl.value === AdminEnum.Misc ? data.activityEvent.actor.name : "");

    this.endLocationControl = new UntypedFormControl({ value: data.activityEvent.endLocation, disabled: !this.canEdit() });

    if (data.activityEvent.type === BusEnum.Air) {
      this.endLocationControl.setValidators(Validators.required);
    }

    this.driverControl = new UntypedFormControl({ value: data.activityEvent.selectedUserMappingId, disabled: !this.canReAssign() }, Validators.required);
    this.startTimeControl = new UntypedFormControl({ value: moment(data.activityEvent.newStart.toDateLocal()).format("HH:mm"), disabled: !this.canEdit }, TimeValidation());

    if (!this.canEditDuration() && data.end) {
      let duration = DateTimeUtils.calculateDurationNumber(data.activityEvent.newStart.toDateLocal(), data.end.toDateLocal());
      this.durationControl.setValue(duration);
    }

    this.title = data.mode === EditModeEnum.Edit ? "Hantera uppdrag" : "Tilldela uppdrag";
    this.actor = data.activityEvent.actor;
    this.timeGroup = this.fb.group({
      driver: this.driverControl,
      duration: this.durationControl,
      startTime: this.startTimeControl
    },
      {
        validator: this.driverValidation()
      });

    this.formTest = this.fb.group(
      {
        time: this.timeGroup,
        comment: this.commentControl,
        startLocation: this.startLocationControl,
        endLocation: this.endLocationControl,
        type: this.typeControl,
        billed: this.billedControl,
        description: this.descriptionControl,
        typeName: this.typeNameControl
      });

    if (data.activityEvent.type !== BusEnum.Transfer && data.activityEvent.type !== BusEnum.Air) {
      this.onChangeType(this.typeNameControl.value, data.mode !== EditModeEnum.Edit);
    }
  }

  ngOnInit() {

    this.durationControl.valueChanges.subscribe(value => {
      // save duration changed by user
      if (this.typeNameControl.value != AdminEnum.Break) {
        this.data.activityEvent.duration = value;
      }
    });
  }

  getEventIcon(event: EventType) {
    if (this.eventPicker) {
      if (!this.eventPicker.panelOpen)
        return "";
      else
        return event.icon;
    }
    else
      return "";
  }

  copyToData() {
    this.data.activityEvent.dirtyActor = this.billedControl.dirty || this.typeNameControl.dirty || this.descriptionControl.dirty || this.typeControl.dirty;
    this.data.activityEvent.dirtyActivity = this.startLocationControl.dirty || this.endLocationControl.dirty ||
      this.startTimeControl.dirty || this.durationControl.dirty || this.commentControl.dirty || this.driverControl.dirty;
    this.data.activityEvent.comment = this.commentControl.value;
    this.data.activityEvent.startLocation = this.startLocationControl.value;
    this.data.activityEvent.endLocation = this.endLocationControl.value;
    this.data.activityEvent.selectedUserMappingId = this.driverControl.value;
    this.data.activityEvent.startTime = this.startTimeControl.value;
    this.data.activityEvent.duration = this.durationControl.value;
    this.data.activityEvent.billed = this.canBeBilled() ? this.billedControl.value : false;
    this.data.activityEvent.actor = this.actor;

    if (this.typeControl.value !== BusEnum.Air && this.typeControl.value !== BusEnum.Transfer) {
      if (this.typeNameControl.value === AdminEnum.Break) {
        this.data.activityEvent.type = BusEnum.Admin;
        this.data.activityEvent.actor.name = AdminEnum.Break;
      }
      else if (this.typeNameControl.value === AdminEnum.Misc) {
        this.data.activityEvent.type = BusEnum.Misc;
        this.data.activityEvent.actor.name = this.descriptionControl.value;
      }
      else if (this.typeNameControl.value === AdminEnum.Meeting) {
        this.data.activityEvent.type = BusEnum.Admin;
        this.data.activityEvent.actor.name = AdminEnum.Meeting;
      }
      else if (this.typeNameControl.value === AdminEnum.Flight) {
        this.data.activityEvent.type = BusEnum.Misc;
        this.data.activityEvent.actor.name = AdminEnum.Flight;
        this.data.activityEvent.actor.description = this.descriptionControl.value;
      } else if (this.typeNameControl.value === AdminEnum.BusBooking) {
        this.data.activityEvent.type = BusEnum.Misc;
        this.data.activityEvent.actor.name = AdminEnum.BusBooking;
        this.data.activityEvent.actor.description = this.descriptionControl.value;
        
      } else {
        this.data.activityEvent.type = BusEnum.Misc;
        this.data.activityEvent.actor.name = this.typeNameControl.value;
      }
    }
    else {
      this.data.activityEvent.type = this.typeControl.value;
    }
  }

  onDurationChange() {
  }

  setDescriptionChars() {
    if (this.typeNameControl.value == AdminEnum.Misc) {
      var desc = this.descriptionControl.value;
      this.descriptionControl.setValidators([Validators.required]);
      this.descriptionControl.setValue(desc);
    }
    else {
      this.descriptionControl.clearValidators();
    }
  }

  driverValidation(): ValidatorFn {
    return (group: UntypedFormGroup) => {

      // Get existing assignments for the driver
      let driverControl: AbstractControl = group.controls['driver'];
      let startTimeControl: AbstractControl = group.controls['startTime'];
      if (startTimeControl.valid) {
        let eventStart = this.parseTime(this.data.activityEvent.newStart, startTimeControl.value);

        let workShift: WorkShift = this.data.workShifts.find(e => e.userMappingID == driverControl.value);
        if (workShift) {

          if (workShift.isWorking(eventStart)) {
            return;
          }
          else {
            return { 'notWorking': true };
          }
        }

      }
      return null;
    }
  };

  save() {
    if (this.formTest.valid) {
      this.copyToData();
      this.dialogRef.close(this.data);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  showDescription() {
    return this.typeNameControl.value === AdminEnum.Misc || this.typeNameControl.value === AdminEnum.Flight || this.typeNameControl.value === AdminEnum.BusBooking;
  }

  unassign() {
    this.copyToData();
    this.data.command = "unassign"
    this.dialogRef.close(this.data);
  }

  cancelActivity() {
    this.copyToData();
    this.data.command = "cancelActivity";
    this.dialogRef.close(this.data);
  }

  canEditDuration() {
      return this.canEdit();
  }

  canEdit() {
    return !(this.data.state == StateMachineEventEnum.Cancel ||
      this.data.state == StateMachineEventEnum.Final ||
      this.data.state == StateMachineEventEnum.Finish);
  }

  canReAssign() {
    return this.canEdit() && (this.data.unassign || this.data.activityEvent.type == BusEnum.Admin || this.data.activityEvent.type == BusEnum.Misc);
  }

  canChangeType() {

    return this.data.state ? this.data.state == StateMachineEventEnum.Assign || this.data.state == StateMachineEventEnum.Planned : true;
  }

  canBeBilled() {
    return (this.data.activityEvent.actor.type != BusEnum.Transfer) &&
      (this.data.activityEvent.actor.type == BusEnum.Air
      || (this.data.activityEvent.type == BusEnum.Misc && this.miscName == AdminEnum.Misc)
      || (this.data.activityEvent.type == BusEnum.Misc && this.miscName == AdminEnum.Flight)
      || (this.data.activityEvent.type == BusEnum.Misc && this.miscName == AdminEnum.BusBooking)
      );
  }

  canSave() {

    if (this.canEdit()) {

      if (this.data.mode === EditModeEnum.Edit) {
        return this.formTest.valid && this.formTest.dirty;
      }
      else
        return this.formTest.valid;
    }
    else
      return false;
  }

  canUnassign() {
    return this.data.unassign;
  }

  canCancelActivity() {
    return this.data.cancel;
  }

  isFlight(actorType) {
    return actorType === 'BKSAIR';
  }

  handleType(id) {
    // Can not change type for Transfer and Air
    if (this.data.activityEvent.type !== BusEnum.Air && this.data.activityEvent.type !== BusEnum.Transfer) {
      if (id === AdminEnum.Misc) {
        this.setDescriptionChars();
      }
      else {
        this.descriptionControl.clearValidators();
        this.descriptionControl.setErrors(null);
      }

      var event = EventTypes.find(x => x.name === id);
      if (event) {
        this.data.activityEvent.type = event.id;
      }

      if (event && event.defaultTime > 0 && !this.existing) {
        this.durationControl.setValue(event.defaultTime);
        this.durationControl.disable();
      }
      else {
        this.durationControl.setValue(this.data.activityEvent.duration);
      }

      if (this.canEditDuration()) {
        this.durationControl.enable();
      }
    }
  }

  onChangeType(name, handle: boolean = true) {
    this.miscName = name;

    if (this.miscName === AdminEnum.Misc) {
      this.data.activityEvent.type = BusEnum.Misc;
    }
    if (handle) {
      this.handleType(name);
    }
  }

  hasStartLocation() {
    if (this.miscName === AdminEnum.Flight || this.miscName === AdminEnum.Misc || this.miscName === AdminEnum.BusBooking)
      return true;
    return false;
  }

  hasEndLocation() {
    return this.hasStartLocation();
  }

  canEditLocation() {
    return this.data.activityEvent.type == BusEnum.Transfer
      || this.miscName === AdminEnum.Misc
      || this.miscName === AdminEnum.Flight
      || this.miscName === AdminEnum.BusBooking;
  }

  sortAvailabilities(input: any): any {
    return input.sort((a, b) => {
      var aStart = new DayPilot.Date(a.availability.start, true);
      var bStart = new DayPilot.Date(b.availability.start, true);
      if (aStart < bStart) return -1;
      else if (aStart > bStart) return 1;
      if (aStart === bStart) {
        var aEndDate = moment(a.availability.duration, 'LTS');
        var bEndDate = moment(b.availability.duration, 'LTS');
        if (aEndDate < bEndDate) return -1;
        else if (aEndDate > bEndDate) return 1;
      }
      else return 0;
    });
  }

  makeEndDateOfDurationTime = function (duration, startTime) {
    var hours = duration.substring(0, 2);
    var minutes = duration.substring(3, 5);
    var seconds = duration.substring(6, 8);
    var endDate = new DayPilot.Date(startTime, true).addHours(hours).addMinutes(minutes).addSeconds(seconds);
    return endDate;
  }

  parseTime(startDate: DayPilot.Date, startTime: string): Date {
    var d = startDate.toDateLocal();

    var time = startTime.match(/(\d+)(?::(\d\d))?\s*(p?)/);
    if (time) {
      d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
      d.setMinutes(parseInt(time[2]) || 0);

      return d;
    }
    return null;

  }

}

class EventType {
  id: string;
  name: string;
  icon: string;
}
